module.exports = __webpack_public_path__ + "static/bg.963818c3.png";